/*******************************************************************************
 *** MbrMng ** 회원 관리 * 회원 리스트
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import TextBox from "@/js/common/ui/input/TextBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import MbrAprvMngDialog from "./dialog/MbrAprvMngDialog";

const MbrMng = () => {
    // 검색 조건
    const [keyword  , setKeyword  ] = React.useState<string>("");  // 검색어(ID/이름) - 화면 필터링용
    const [upOgnzCd  , setUpOgnzCd  ] = React.useState<string>("");  // 1차 소속 코드(본부)
    const [ognzCd    , setOgnzCd    ] = React.useState<string>("");  // 2차 소속 코드(지부)
    const [searchAtrzSttsCd , setSearchAtrzSttsCd ] = React.useState<string>("");  // 가입상태코드

    const [dataArr   , setDataArr   ] = React.useState<[]>([]);   // 회원 리스트 데이터

    // 모달 상태
    const [memberModalOpen, setMemberModalOpen] = React.useState<boolean>(false); // 회원상세정보 모달
    const [userId   , setUserId   ] = React.useState<string>("");
    const [userNm   , setUserNm   ] = React.useState<string>("");
    const [callTime , setCallTime ] = React.useState<Date>(new Date());

    // GridTable 컬럼 정의
    const fldInfs: fldInfsProps[] = [
        { type: "seq"                      , width:  50, headAlign: "center", dataAlign: "center", label: "No."        },
        { type: "text", fldNm: "userId"    , width: 120, headAlign: "center", dataAlign: "center", label: "아이디"     },
        { type: "text", fldNm: "userNm"    , width:  90, headAlign: "center", dataAlign: "center", label: "이름"       },
        { type: "phone", fldNm: "telno"    , width: 140, headAlign: "center", dataAlign: "center", label: "전화번호"   },
        { type: "text", fldNm: "upOgnzNm"  , width: 120, headAlign: "center", dataAlign: "center", label: "본부"       },
        { type: "text", fldNm: "ognzNm"    , width: 140, headAlign: "center", dataAlign: "center", label: "지부"       },
        { type: "text", fldNm: "jbpsSeNm"  , width: 120, headAlign: "center", dataAlign: "center", label: "직위"       },
        { type: "text", fldNm: "mbrAuthNm" , width:  90, headAlign: "center", dataAlign: "center", label: "조합원 권한" },
        { type: "text", fldNm: "feeAuthNm" , width:  90, headAlign: "center", dataAlign: "center", label: "조합비 권한" },
        { type: "text", fldNm: "crtDt"     , width: 140, headAlign: "center", dataAlign: "center", label: "가입일자"   },
        { type: "code", fldNm: "joinSttsCd", width: 100, headAlign: "center", dataAlign: "center", label: "상태", catCode: "JOIN_STTS_CD"},
    ];

    // 회원 목록 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url        : "system/mbr/mng/select-mbr-list.do",
            methodType : "post",
            paramType  : "json",
            paramData  : {
                upOgnzCd  : upOgnzCd,
                ognzCd    : ognzCd,
                searchAtrzSttsCd: searchAtrzSttsCd
            },
            onSuccessFn: (res: any) => {
                setDataArr(res.result.list);
                AppContext.hideSpinner();
            },
        });
    }, [callTime, upOgnzCd, ognzCd, searchAtrzSttsCd]);

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">

            {/* 타이틀 */}
            <div className="mt5">
                <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">회원 관리</span>
                <div className="bdt3 bdc007bff pb10"></div>
            </div>

            {/* 검색 조건 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    {/* 검색어(ID/이름) */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">이름</span>
                        <TextBox value={keyword}
                            width={150} height={36} fontSize={14}
                            fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="이름 입력"
                            onChangeFunc={(text: string) => setKeyword(text)}
                        />
                    </div>

                    {/* 1차 소속(본부) */}
                    <div className="dpFlx aiC">
                        <span className="w60 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36} fontSize={14} fontFamily="fm-c" color="#333"
                            letterSpacing={-1} borderColor="#ddd" borderOnColor="#222"
                            borderRadius={2} background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getUpOrgCodeArray("01"))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => {
                                setUpOgnzCd(data);
                                setOgnzCd("");
                            }}
                        />
                    </div>

                    {/* 2차 소속(지부) */}
                    <div className="dpFlx aiC">
                        <span className="w60 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36} fontSize={14} fontFamily="fm-c" color="#333"
                            letterSpacing={-1} borderColor="#ddd" borderOnColor="#222"
                            borderRadius={2} background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                        />
                    </div>

                    {/* 회원상태 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회원상태</span>
                        <SelectBox value={searchAtrzSttsCd}
                            width={180} height={36} fontSize={14} fontFamily="fm-c" color="#333"
                            letterSpacing={-1} borderColor="#ddd" borderOnColor="#222"
                            borderRadius={2} background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_JOIN_STTS_CD_01"))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => setSearchAtrzSttsCd(data)}
                        />
                    </div>

                    {/* 초기화 버튼 */}
                    <div className="dpFlx aiC mlA">
                        <Button
                            width={70} height={40} fontFamily="fm-b"
                            fontSize={16} letterSpacing={-1}
                            variant="styInitBtn" borderRadius={5}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="초기화"
                            onClickFunc={() => {
                                setKeyword("");
                                setUpOgnzCd("");
                                setUpOgnzCd("");
                                setOgnzCd("");
                                setSearchAtrzSttsCd("");
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* 목록 타이틀 */}
            <div className="dpFlx aiC jcSb mb10 h44">
                <div className="fm-b fs16 fc007bff ls1 fw700">회원 목록</div>
            </div>

            {/* 목록 */}
            <GridTable tableInfo={{
                tableHeadVsb: true, styleType: AdminGridStyle,
                fldInfs: fldInfs,
                dataArr: Util.filterFieldData(dataArr, fldInfs, "userNm", keyword),
                maxRowNums: [10, 30, 50],
                theadTrHeight: 40, tbodyTrHeight: 35, paginateClass: "pt10",
                paginateStyle: {
                    buttonOnColor: AppContext.boardThemeColor, buttonWidth: 22,
                    buttonHeight: 24, buttonMarginLeft: 1, buttonMarginRight: 1,
                    fontSize: 13, color: "#666666", letterSpacing: -0.8,
                    fontFamily: "Pretendard-Regular", borderRadius: 3,
                },
                footerVsb: true,
                rowClickFunc: (item: any) => {
                    setUserId(item.userId);
                    setUserNm(item.userNm);
                    setMemberModalOpen(true);
                },
            }} />

            {/* 회원 상세정보 모달 */}
            <Modal modalOpen={memberModalOpen} dim={true} visible={true} width={640}
                titleEl={<DialogTitleBar title={"회원 상세정보"}/>}
                onCloseFunc={() => {
                    setUserId("");
                    setMemberModalOpen(false);
                }}
            >
                <MbrAprvMngDialog userId={userId} userNm={userNm} setCallTime={setCallTime} setMemberModalOpen={setMemberModalOpen}/>
            </Modal>

        </div>
    );
};

export default MbrMng;